//*** Import React Library
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Axios from 'axios'
import "../../Assets/Styles/robot.css";
import { hasJWTToken } from "../Account/RouteGuard";
import "../../Assets/Styles/Form.css";
import * as FaIcons from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
//*** Create custom style for react table
const customStyles = {
    table: {
        style: {
            border: "none",
            fontSize: "100%"
        },
    },
    header: {
        backgroundColor: "transparent",
    },
    rows: {
        style: {
            backgroundColor: "transparent",
        },
    },
    headRow: {
        style: {
            backgroundColor: "transparent",
            fontSize: "110%"
        },
    },
    pagination: {
        style: {
            backgroundColor: "transparent",
            fontWeight: "600",
        },
    },
    headCells: {
        style: {
            borderBottom: "none",
            fontWeight: "700",
            fontSize: "110%"
        },
    },
};
export const SearchBlockRows = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [blockRowData, setBlockRowData] = useState([]);
    const [blockRowList, setBlockRowList] = useState([]);
    const [blockRowID, setBlockRowID] = useState("");
    const [blockName, setBlockName] = useState("");
    //*** Create columns for react table
    const columns = [
        { name: "ID", selector: (row) => <a className="alink" onClick={() => editBlokRows(row.block_row_id)}>{row.block_id}</a>, sortable: true, },
        { name: "Plant Name", selector: (row) => row.plant_name, sortable: true, },
        { name: "Block Name", selector: (row) => row.block_name, sortable: true },
        { name: "Row Name", selector: (row) => row.row_name, sortable: true },
        { name: "Date", selector: (row) => row.block_row_added_date, sortable: true },
        { name: "Delete", selector: (row) => <a className="alink" onClick={() => showModal(row.block_row_id, row.row_name)}>Delete</a>, sortable: true, },
    ];
    //** Show Modal
    const showModal = (block_row_id, block_name) => {
        setBlockRowID(block_row_id);
        setBlockName(block_name);
        var divmodal = document.getElementById("dvmodal");
        var divMessage = document.getElementById("dvMessage");
        divmodal.style.display = "block";
        divMessage.innerText = "are you sure to delete Block Rows ID '" + block_row_id + "'?"
        divmodal.scrollIntoView();
    };
    //** Hide Modal
    const hideModal = (dvmodal) => {
        var dvimodal = document.getElementById(dvmodal);
        dvimodal.style.display = "none";
    };
    //** editBlockRow
    const editBlokRows = (blockRowID) => {
        sessionStorage.removeItem("editBlockRowID");
        sessionStorage.setItem("editBlockRowID", blockRowID);
        window.location.href = "#/EditBlockRow?pid=" + blockRowID + "";
    };
    //** Delete Records
    const deleteRecord = async () => {
        var user_id = sessionStorage.getItem("user_id");
        let response = await Axios("/BlockRows/DeleteBlockRows?brid=" + blockRowID + "&uid=" + user_id + "&pn=DeleteBlockRow");
        hideModal("dvmodal");
        fetchBlockRowData();
    }
    //*** Seach Textbox text change event
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        let tempList = blockRowData;
        const filteredData = tempList.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm)
            )
        );
        if (event.target.value != null) {
            setBlockRowList(filteredData);
        }
        if (event.target.value === "") {
            setBlockRowList(blockRowData);
        }
    };
    //*** Filter table
    const filteredData = blockRowList.filter((event) =>
        Object.values(event).some(
            (value) => typeof value === "string" && value.includes(searchTerm)
        )
    );
    //*** Use React hooks - if occur any changes on page then useffect() function will run auto
    useEffect(() => {
        fetchBlockRowData();
    }, [])
    useEffect(() => {
        console.log(blockRowData)
    }, [blockRowData])
    //*** Fetch data from API // To Search 94fbr
    const fetchBlockRowData = async () => {
        var block_row_id = "1" //sessionStorage.getItem("editBlockId");
        var user_id = sessionStorage.getItem("user_id");
        var _token = sessionStorage.getItem("token");
        if (_token) _token = "Token exists";
        let response = await Axios("/PlantBlockRow?brid=" + block_row_id + "&uid=" + user_id + "&pn=SearchBlockRow&sn=SearchAllBlockRow");
        setBlockRowData(response.data)
        setBlockRowList(response.data)
    }
    return (
        <div className="page-container">
            <div className="search-container">
                <h2 className="form-title"><FaIcons.FaSearch /> Search Block Row</h2>
                <div class="row">
                    <div class="col-1"></div>
                    <div class="col-12"><a className="btndelete" href="#/PlantBlockRow">Add New Block Row</a></div>
                </div>
                <div>
                    <div
                        style={{
                            border: "1px solid #c0c0c0",
                            borderRadius: "5px",
                            margin: "2%",
                            backgroundColor: "#fff",
                        }}
                    >
                        <div className="container dvscroll" >
                            <div className="row dvscroll">
                                <div className="col-sm-12">
                                    <input
                                        type="text"
                                        placeholder="Search Results"
                                        style={{
                                            width: "20%",
                                            height: "30px",
                                            margin: "10px",
                                            float: "right",
                                            border: "none",
                                            padding: "1.5%",
                                            borderRadius: "5px",
                                        }}
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                    <p></p>
                                    <DataTable className="table .table-sm table-hover" sort={true} pagination={true}
                                        search={true}
                                        columns={columns}
                                        data={filteredData}
                                        highlightOnHover={true}
                                        customStyles={customStyles}
                                    >
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="dvmodal" class="modalcontainer">
                    <Modal.Dialog size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                    >
                        <Modal.Header closeButton onClick={() => hideModal("dvmodal")}>
                            <Modal.Title>
                                Delete Block Rows
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>
                                <div id="dvMessage"></div>
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <a variant="secondary" className="btndelete" onClick={() => deleteRecord()}>
                                Delete
                            </a>
                            <a variant="secondary" className="btncancel" onClick={() => hideModal("dvmodal")}>
                                Cancel
                            </a>
                        </Modal.Footer>
                    </Modal.Dialog>
                </div>
            </div>
        </div>
    );
}
export default SearchBlockRows;